export default {
  state: {
    // index of offboarding steps
    // 0 - didn't start
    // 1 - feedback
    // 2 - confirmation
    // 3 - completion
    offboardingIndex: 0,
    offboardingQuestionnaireResponse: {},
  },
  mutations: {
    setOffboardingIndex(state, value) {
      state.offboardingIndex = value;
    },
    setOffboardingQuestionnaireResponse(state, { offboardingReason, otherReason }) {
      state.offboardingQuestionnaireResponse = { offboardingReason, otherReason };
    },
  },
  actions: {
    updateOffboardingIndex({ commit }, value) {
      commit('setOffboardingIndex', value);
    },
    updateOffboardingQuestionnaireResponse({ commit }, { offboardingReason, otherReason }) {
      commit('setOffboardingQuestionnaireResponse', { offboardingReason, otherReason });
    },
  },
  getters: {
    offboardingIndex: (state) => state.offboardingIndex,
    offboardingQuestionnaireResponse: (state) => state.offboardingQuestionnaireResponse,
  },
};
